export default __webpack_public_path__ + "static/media/HelveticaNeue Bold.61acdee6.ttf";